module.exports = __webpack_public_path__ + "img/coming-soon.0c394e21.png";